import { IPublisherStyleResponse } from '../model';
import { fetchBase } from 'tag/models/common/fetchData/fetch-base';

export const fetchPublisherStyles = (publisher: string): Promise<IPublisherStyleResponse> => {
  const url = `./json/${publisher}.json`;
  return fetchBase<IPublisherStyleResponse>(url);
};
